<div class="leaderboard-page">
    <section class="lb-hero">
        <div class="hero-bg"></div>
        <div class="hero-overlay"></div>
        <div class="container hero-inner">
            <h1>Leaderboard</h1>
            <p><strong>Compete with players from around the world.</strong> Climb the ranks, earn points, and become a champion.</p>
        </div>
    </section>

    <section class="lb-content">
        <div class="container">
            <div class="top-panel" *ngIf="userDetails!=null">
                <div class="invite-copy">
                    <h3>Referral Boost</h3>
                    <p>Invite friends and earn extra points when they join.</p>
                </div>
                <button class="cta" data-toggle="modal" data-target="#referralModal" (click)="generateReferralCode()">
                    Generate Invite Link <i class="fa fa-link"></i>
                </button>
            </div>

            <div *ngIf="!useersLoaded" class="state-block">Loading leaderboard...</div>
            <div *ngIf="useersLoaded && userAccounts.length===0" class="state-block">No leaderboard data available yet.</div>

            <div class="stats-shell" *ngIf="useersLoaded && userAccounts.length > 0">
                <h2>Leaderboard</h2>
                <div class="board-head">
                    <span>Rank</span>
                    <span>Name</span>
                    <span>Points</span>
                </div>

                <div
                    class="board-row"
                    [class.current-user]="isCurrentUser(userAccount)"
                    *ngFor="let userAccount of userAccounts | paginate: { itemsPerPage: pageSize, currentPage: pageNo, totalItems: totalRecords }; let i = index">
                    <div class="rank-cell">
                        <span class="rank-number">{{ i + 1 + (pageNo - 1) * pageSize }}</span>
                        <i class="fa" [ngClass]="(i % 2 === 0) ? 'fa-arrow-circle-up up' : 'fa-arrow-circle-down down'"></i>
                    </div>
                    <div class="name-cell">
                        <strong>{{ userAccount.user.userName }}</strong>
                    </div>
                    <div class="points-cell">
                        <span class="cell-label">Points</span>
                        <span class="points-value">{{ userAccount.points | number }}</span>
                    </div>
                </div>

                <div class="pagination-wrap">
                    <pagination-controls [autoHide]="true" (pageChange)="fetchUserAccounts($event)"></pagination-controls>
                </div>
            </div>
        </div>
    </section>

    <div class="modal fade" id="referralModal" tabindex="-1" role="dialog" aria-labelledby="referralModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-lg" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="referralModalLabel"><i class="fa fa-share-alt"></i> Share Your Referral Link</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                </div>
                <div class="modal-body">
                    <div class="referral-link-container">
                        <input type="text" id="referralInput" value="{{baseUrl!+'/yo-games/signup?referral='+referralCodeData?.referralCode}}" readonly class="referral-input">
                        <button class="copy-button" (click)="copyReferralLink()"><i class="fa fa-copy"></i> Copy</button>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn-close" data-dismiss="modal">Close</button>
                </div>
            </div>
        </div>
    </div>
</div>
